import { useQuery } from "@apollo/client";

import { CommunicationTemplate, CommunicationTemplateDTO } from "Types/CommunicationTemplate";

import { findCommunicationTemplateByIdQueue } from "./queries";

type HookProps = {
    templateId?: string;
};

function toDTO(templateData: CommunicationTemplate): CommunicationTemplateDTO {
    return {
        ...templateData,
        teamIds: templateData.teams?.map(({ id }) => id),
    };
}

export function useCommunicationTemplateQueries({ templateId }: HookProps): {
    isLoading: boolean;
    templateData?: CommunicationTemplateDTO;
} {
    const { loading: isLoading, data } = useQuery(findCommunicationTemplateByIdQueue, {
        variables: {
            id: templateId,
        },
        skip: !templateId,
        fetchPolicy: "cache-and-network",
    });

    return {
        isLoading,
        templateData: data?.findCommunicationTemplateById ? toDTO(data.findCommunicationTemplateById) : undefined,
    };
}
